import { atom, getDefaultStore } from 'jotai';

export type UpgradeDialogEventSource =
  | 'fileLimitReached'
  | 'AIMessageCounterBar'
  | 'SelectAIModelMenu'
  | 'AIUsageExceeded'
  | 'DashboardSidebar'
  | 'SettingsDialog'
  | 'ExportDialog';

export type UpgradeSuggestion = { type: 'upgrade'; targetPlan: 'PRO' | 'BUSINESS' } | { type: 'enableOverage' } | null;

type UpgradeDialogState =
  | { open: false; eventSource: null; suggestion?: null; resumeChatId?: undefined }
  | {
      open: true;
      eventSource: UpgradeDialogEventSource;
      suggestion?: UpgradeSuggestion;
      // When the dialog is opened from an in-file AI paywall with a pending
      // (un-answered) prompt, this carries the chat id so the checkout return
      // URL can reopen that thread and auto-submit after a successful upgrade.
      resumeChatId?: string;
    };

export const showUpgradeDialogAtom = atom<UpgradeDialogState>({ open: false, eventSource: null });

export const showUpgradeDialog = (eventSource: UpgradeDialogEventSource, suggestion?: UpgradeSuggestion) => {
  getDefaultStore().set(showUpgradeDialogAtom, { open: true, eventSource, suggestion });
};
